// Relaunch 2026: Texte der vier Bestandsseiten in einfacher Sprache.
// Inhaltlich verdichtet aus den bisherigen Lösungsseiten und der Vertriebspräsentation rev 05.
// Sprachstand Oktober 2026: sprachlich angehoben, „Bestandsliste“ einheitlich.

export const relaunchStock = {
    de: {
        "surplus-excess": {
            num: "01",
            situation: "surplus",
            title: "Überbestände",
            heroTitle: "Mehr auf Lager, als Sie brauchen?",
            heroSub: "Zu hohe Mindestmengen, ausgelaufene Projekte, veränderter Bedarf. Parto bringt den Überschuss zurück in den Markt.",
            questionsTitle: "Kennen Sie das?",
            questions: [
                "Niemand weiß genau, was davon noch gebraucht wird.",
                "Das Lager ist voll, aber der Bestand bewegt sich nicht.",
                "Für einen Verkauf fehlen Zeit und Personal.",
                "Händler wollen nur die besten Positionen.",
            ],
            statement: "Von „brauchen wir nicht mehr“ bis „ist verkauft“ übernimmt Parto die gesamte Arbeit.",
            stepsTitle: "So gehen wir vor",
            steps: [
                { num: "01", title: "Überblick schaffen", text: "Sie senden uns Ihre Bestandsliste. Wir trennen gefragte Positionen von schwer verkäuflichen." },
                { num: "02", title: "Gemeinsam freigeben", text: "Sie entscheiden, welche Teile in den Verkauf gehen. Alles andere bleibt bei Ihnen." },
                { num: "03", title: "Übernehmen und anbieten", text: "Wir holen die Ware ab, erfassen jede Position und bieten sie über den passenden Weg an." },
                { num: "04", title: "Verkaufen und abrechnen", text: "Sie sehen jeden Verkauf und erhalten eine nachvollziehbare Abrechnung." },
            ],
            benefitsTitle: "Was Sie davon haben",
            benefits: [
                { title: "Liquidität", text: "Kapital, das im Lager gebunden ist, fließt zurück." },
                { title: "Platz", text: "Lagerfläche wird frei für das, was Sie brauchen." },
                { title: "Weniger Aufwand", text: "Ihre Mitarbeiter müssen sich nicht um den Verkauf kümmern." },
            ],
        },
        "mro-spare-parts": {
            num: "02",
            situation: "mro",
            title: "Ersatzteile",
            heroTitle: "Ihr Ersatzteillager ist über Jahre gewachsen?",
            heroSub: "Zu viel bindet Kapital, zu wenig gefährdet die Produktion. Kritische Teile bleiben, nur echter Überschuss geht.",
            questionsTitle: "Kennen Sie das?",
            questions: [
                "Teile liegen seit Jahren, könnten aber im Störfall entscheidend sein.",
                "Maschinen wurden ersetzt, ihre Ersatzteile sind geblieben.",
                "Instandhaltung, Einkauf und Finanzen bewerten den Bestand unterschiedlich.",
                "Niemand will das falsche Teil abgeben.",
            ],
            statement: "Die Frage ist nicht, wie viel gehen kann. Die Frage ist, was Ihre Anlagen wirklich brauchen.",
            stepsTitle: "So gehen wir vor",
            steps: [
                { num: "01", title: "Bestand verstehen", text: "Jedes Teil wird seiner Anlage zugeordnet und auf Wiederbeschaffbarkeit geprüft." },
                { num: "02", title: "Gemeinsam einteilen", text: "Mit Ihrer Instandhaltung legen wir fest: behalten, beobachten oder freigeben." },
                { num: "03", title: "Freigegebenes übernehmen", text: "Nur was Sie freigeben, holen wir ab, erfassen es und bieten es an." },
                { num: "04", title: "Verkaufen und dokumentieren", text: "Sie erhalten Abrechnung und Nachweise, jede Position einzeln." },
            ],
            benefitsTitle: "Was Sie davon haben",
            benefits: [
                { title: "Versorgungssicherheit", text: "Kritische Teile bleiben verfügbar, nichts verlässt versehentlich das Lager." },
                { title: "Klarheit", text: "Sie wissen, welche Teile zu welcher Anlage gehören." },
                { title: "Günstiger beschaffen", text: "Über HubParto beschaffen Sie Ersatzteile zu fairen Preisen." },
            ],
        },
        "obsolete-slow-moving": {
            num: "03",
            situation: "obsolete",
            title: "Veraltete Teile",
            heroTitle: "Teile, die seit Jahren nicht bewegt wurden?",
            heroSub: "Was bei Ihnen stillsteht, wird anderswo gesucht. Gerade für abgekündigte Teile gibt es feste Abnehmer.",
            questionsTitle: "Kennen Sie das?",
            questions: [
                "Produktlinien sind ausgelaufen, das Material ist geblieben.",
                "Hersteller haben Teile abgekündigt.",
                "Der Buchwert steht noch, der Marktwert ist unklar.",
                "Am Ende landet alles im Schrott.",
            ],
            statement: "Entscheidend ist nicht das Alter eines Teils, sondern ob es heute noch gebraucht wird.",
            stepsTitle: "So gehen wir vor",
            steps: [
                { num: "01", title: "Einordnen", text: "Gemeinsam prüfen wir, was noch kritisch ist und was gehen darf." },
                { num: "02", title: "Marktwert ermitteln", text: "Wir analysieren, wo diese Teile noch gefragt sind und welchen Erlös sie dort erzielen." },
                { num: "03", title: "Anbieten", text: "Einzeln, per Ausschreibung an Händler oder als Posten. Je nachdem, was mehr Erlös bringt." },
                { num: "04", title: "Sauber abschließen", text: "Was nicht mehr verkäuflich ist, wird dokumentiert recycelt." },
            ],
            benefitsTitle: "Was Sie davon haben",
            benefits: [
                { title: "Restwert", text: "Auch ältere Teile haben einen Marktwert, denn Betreiber älterer Anlagen suchen genau diese Teile." },
                { title: "Ein klarer Abschluss", text: "Kein Teil bleibt ohne Weg im Lager liegen." },
                { title: "Nachweise", text: "Recycling mit Dokumentation für Ihre Unterlagen." },
            ],
        },
        "plant-closures": {
            num: "04",
            situation: "closure",
            title: "Werksschließung",
            heroTitle: "Ein Standort schließt oder zieht um?",
            heroSub: "Tausende Teile, ein fester Termin, ein ausgelastetes Team. Parto räumt von der Erfassung bis zur Abrechnung.",
            questionsTitle: "Was jetzt geklärt werden muss",
            questions: [
                "Was geht an einen anderen Standort?",
                "Was bleibt als Reserve für andere Anlagen?",
                "Was kann verkauft werden?",
                "Was wird recycelt?",
            ],
            statement: "Für jedes Teil rechtzeitig den richtigen Weg finden. Darin liegt die eigentliche Aufgabe.",
            stepsTitle: "So gehen wir vor",
            steps: [
                { num: "01", title: "Umfang festlegen", text: "Wir begehen den Standort mit Ihnen und planen nach Hallen, Wert und Termin." },
                { num: "02", title: "Erfassen", text: "Jedes Teil wird vor Ort mit Foto und Typenschild aufgenommen." },
                { num: "03", title: "Wege zuordnen", text: "Mitnehmen, behalten, verkaufen oder recyceln. Sie entscheiden, wir setzen um." },
                { num: "04", title: "Räumen und abrechnen", text: "Wir übernehmen Abtransport, Verkauf und Abrechnung im vereinbarten Zeitplan." },
            ],
            benefitsTitle: "Was Sie davon haben",
            benefits: [
                { title: "Termintreue", text: "Ein Plan, der verlässlich zum Übergabetermin passt." },
                { title: "Entlastung", text: "Ihre Mitarbeiter konzentrieren sich auf den Umzug." },
                { title: "Ein Ansprechpartner", text: "Für alle Wege und alle Hallen." },
            ],
        },
        common: {
            eyebrow: "Für Ihren Bestand",
            back: "Alle Bestandsarten",
            cta: "Bestand anfragen",
            secondary: "So arbeiten wir",
            othersTitle: "Weitere Ausgangslagen",
            quoteBy: "Artur Schlee · Geschäftsführer",
            howLabel: "Ablauf",
            benefitsLabel: "Ihr Vorteil",
        },
    },
    en: {
        "surplus-excess": {
            num: "01",
            situation: "surplus",
            title: "Surplus stock",
            heroTitle: "More in stock than you need?",
            heroSub: "Order minimums too high, projects ended, demand changed. Parto brings the surplus back to the market.",
            questionsTitle: "Sound familiar?",
            questions: [
                "Nobody knows exactly what is still needed.",
                "The warehouse is full, but the stock does not move.",
                "There is no time or staff to sell it.",
                "Dealers only want the best positions.",
            ],
            statement: "Between “we no longer need it” and “it is sold” lies a lot of work. Parto takes all of it over.",
            stepsTitle: "How we work",
            steps: [
                { num: "01", title: "Get an overview", text: "You send us your inventory list. We separate positions in demand from hard to sell ones." },
                { num: "02", title: "Release together", text: "You decide which parts go up for sale. Everything else stays with you." },
                { num: "03", title: "Take over and offer", text: "We collect the goods, capture every position and offer it through the right route." },
                { num: "04", title: "Sell and settle", text: "You see every sale and receive an auditable statement." },
            ],
            benefitsTitle: "What you gain",
            benefits: [
                { title: "Liquidity", text: "Capital tied up in stock flows back." },
                { title: "Space", text: "Warehouse space is freed for what you need." },
                { title: "Less effort", text: "Your staff do not have to handle the sale." },
            ],
        },
        "mro-spare-parts": {
            num: "02",
            situation: "mro",
            title: "Spare parts",
            heroTitle: "Has your spare parts store grown over the years?",
            heroSub: "Too much ties up capital, too little puts production at risk. Critical parts stay, only true surplus goes.",
            questionsTitle: "Sound familiar?",
            questions: [
                "Parts have sat for years but could be decisive in a breakdown.",
                "Machines were replaced, their spare parts stayed.",
                "Maintenance, procurement and finance assess the stock differently.",
                "Nobody wants to give away the wrong part.",
            ],
            statement: "The question is not how much can go. The question is what your equipment really needs.",
            stepsTitle: "How we work",
            steps: [
                { num: "01", title: "Understand the stock", text: "We link every part to its machine and check how easily it can be sourced again." },
                { num: "02", title: "Classify together", text: "With your maintenance team we decide: keep, monitor or release." },
                { num: "03", title: "Take over what is released", text: "We only collect, capture and offer what you release." },
                { num: "04", title: "Sell and document", text: "You receive statements and records, position by position." },
            ],
            benefitsTitle: "What you gain",
            benefits: [
                { title: "Security of supply", text: "Critical parts stay available, nothing leaves by mistake." },
                { title: "Clarity", text: "You know which parts belong to which machine." },
                { title: "Better sourcing", text: "Source spare parts at fair prices through HubParto." },
            ],
        },
        "obsolete-slow-moving": {
            num: "03",
            situation: "obsolete",
            title: "Obsolete parts",
            heroTitle: "Parts that have not moved for years?",
            heroSub: "What stands still with you is wanted elsewhere. Discontinued parts in particular have steady buyers.",
            questionsTitle: "Sound familiar?",
            questions: [
                "Product lines ended, the material stayed.",
                "Manufacturers have discontinued parts.",
                "The book value is there, the market value is unclear.",
                "In the end, everything ends up as scrap.",
            ],
            statement: "What counts is not how old a part is, but whether it is still needed today.",
            stepsTitle: "How we work",
            steps: [
                { num: "01", title: "Classify", text: "Together we check what is still critical and what can go." },
                { num: "02", title: "Determine the market value", text: "We analyse where these parts are still in demand and what return they achieve there." },
                { num: "03", title: "Offer", text: "Individually, by tender to dealers or as a lot. Whichever returns more." },
                { num: "04", title: "Close cleanly", text: "What can no longer be sold is recycled with documentation." },
            ],
            benefitsTitle: "What you gain",
            benefits: [
                { title: "Residual value", text: "Even older parts often still achieve a return." },
                { title: "A clear finish", text: "No part stays in the warehouse without a route." },
                { title: "Proof", text: "Documented recycling for your records." },
            ],
        },
        "plant-closures": {
            num: "04",
            situation: "closure",
            title: "Plant closure",
            heroTitle: "A site is closing or moving?",
            heroSub: "Thousands of parts, a fixed date, a fully stretched team. Parto clears everything from capture to settlement.",
            questionsTitle: "What needs to be decided now",
            questions: [
                "What moves to another site?",
                "What stays as a reserve for other machines?",
                "What can be sold?",
                "What will be recycled?",
            ],
            statement: "Finding the right route for every part in time. That is the real task.",
            stepsTitle: "How we work",
            steps: [
                { num: "01", title: "Define the scope", text: "We walk the site with you and plan by hall, value and deadline." },
                { num: "02", title: "Capture", text: "Every part is recorded on site with photo and type plate." },
                { num: "03", title: "Assign routes", text: "Move, keep, sell or recycle. You decide, we execute." },
                { num: "04", title: "Clear and settle", text: "We handle removal, sale and settlement on the agreed schedule." },
            ],
            benefitsTitle: "What you gain",
            benefits: [
                { title: "On time", text: "A plan that reliably fits your handover date." },
                { title: "Relief", text: "Your staff can focus on the move." },
                { title: "One point of contact", text: "For every route and every hall." },
            ],
        },
        common: {
            eyebrow: "Your inventory",
            back: "All inventory types",
            cta: "Request a review",
            secondary: "How we work",
            othersTitle: "Other starting points",
            quoteBy: "Artur Schlee · Managing Director",
            howLabel: "Process",
            benefitsLabel: "Your benefit",
        },
    },
};
